import { post } from '../utility';

export const search = ({ afterDate, beforeDate, terminalIds, callback }) => {
	post({
		method: 'inventoryReports.search',
		params: { afterDate, beforeDate, terminalIds },
		callback,
	});
};
